module.exports = (__webpack_require__(7))(2);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@angular/core/esm5/core.js from dll-reference vendor
// module id = 0
// module chunks = 0